/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 11/07/2025 15:56
 *
 */

import { CartographyTabV2Dto } from '../../module/cartography/types/cartography-tab-v2/cartography-tab-v2.dto';
import { CartographyResourceTypeEnum } from '../../module/cartography/enum/cartography-resource-type.enum';
import { SerializedPresetInterface } from '../../interface/serialized/serialized-preset.interface';

export class MapTabsSetCurrentAction {
  static readonly type = '[MapTab] Set Current';
  constructor(public tab: CartographyTabV2Dto) {}
}

export class MapTabsSelectAction {
  static readonly type = '[MapTab] Select';
  constructor(public id: string) {}
}

export class MapTabsCloseAction {
  static readonly type = '[MapTab] Close';
  constructor(public id: string) {}
}

export class MapTabsClearAction {
  static readonly type = '[MapTab] Clear';
}

export class MapTabsAddIdsAction {
  static readonly type = '[MapTab] Add Ids';
  constructor(
    public ids: string[],
    public type: CartographyResourceTypeEnum,
  ) {}
}

export class MapTabsRemoveIdsAction {
  static readonly type = '[MapTab] Remove Ids';
  constructor(
    public ids: string[],
    public type: CartographyResourceTypeEnum,
  ) {}
}

export class MapTabsSetIdsAction {
  static readonly type = '[MapTab] Set Ids';
  constructor(
    public ids: string[],
    public type: CartographyResourceTypeEnum,
  ) {}
}

export class MapTabsSetSearchAction {
  static readonly type = '[MapTab] MatTabSetBbxSearch';
  constructor(
    public search: string,
    public type: CartographyResourceTypeEnum,
  ) {}
}

export class MapTabsSetFilterAction {
  static readonly type = '[MapTab] Set Filter';
  constructor(public filter: string) {}
}

export class MapTabsSetDisplayModeAction {
  static readonly type = '[MapTab] Set Display Mode';
  constructor(public displayMode: 'map' | 'table') {}
}

export class MapTabsSetCurrentResourceTypeAction {
  static readonly type = '[MapTab] Set Current Resource Type';
  constructor(public resourceType: CartographyResourceTypeEnum) {}
}

export class MapTabsCloseByPresetIdAction {
  static readonly type = '[MapTab] Close By Preset Id';
  constructor(public presetId: string) {}
}

export class MapTabsUpdatePresetAction {
  static readonly type = '[MapTab] Update Preset';
  constructor(public preset: SerializedPresetInterface) {}
}
